module.exports = __webpack_public_path__ + "img/foto-institucional.aeab7a20.jpg";